import { jsx as _jsx } from "react/jsx-runtime";
import "./IntegratedSearchPaginationStyles.scss";
import { parseUrl, stringifyUrl } from "query-string";
import { useEffect, useRef } from "react";
const IntegratedSearchPaginationComponent = (properties) => {
    const { candidatesMatchedQuantityInt, currentPageNumber, pageSize, totalPages } = properties;
    const reference = useRef(null);
    useEffect(() => {
        const windowMath = window.Math;
        // Adjust number of page links for mobile
        const pageLinkMax = window.matchMedia("screen and (max-width: 640px)").matches ? 5 : 10;
        const paginationTotal = windowMath.min(totalPages, windowMath.ceil(candidatesMatchedQuantityInt / pageSize));
        const pagination = reference.current;
        // Clear pagination container
        pagination.innerHTML = "";
        const hrefParsed = parseUrl(window.location.href);
        const { fragmentIdentifier, query, url } = hrefParsed;
        const getUrl = (pageNumber) => {
            const newQuery = Object.assign(Object.assign({}, query), { "page": pageNumber });
            return stringifyUrl({
                "fragmentIdentifier": fragmentIdentifier,
                "query": newQuery,
                "url": url
            });
        };
        // Build pagination, when results exceed configured page_range value
        if (candidatesMatchedQuantityInt / pageSize > 1) {
            // Build prev link
            if (currentPageNumber > 1) {
                const previous = window.document.createElement("li");
                previous.classList.add("previous");
                const link = window.document.createElement("a");
                link.href = getUrl(currentPageNumber - 1);
                link.innerHTML = "&lt;";
                previous.append(link);
                const label = window.document.createElement("span");
                label.innerHTML = "Previous";
                link.append(label);
                pagination.append(previous);
            }
            // Ellipses and first page link
            // Build ellipses
            if (currentPageNumber > windowMath.floor(pageLinkMax / 2)
                && paginationTotal > pageLinkMax
                && currentPageNumber > pageLinkMax / 2 + 1) {
                const ellipses = window.document.createElement("li");
                ellipses.classList.add("ellipses");
                ellipses.innerHTML = "...";
                pagination.append(ellipses);
            }
            let startingPage = void 0;
            // Build page links
            if (currentPageNumber <= candidatesMatchedQuantityInt) {
                if (currentPageNumber <= windowMath.floor(pageLinkMax / 2) || paginationTotal <= pageLinkMax) {
                    // Within range of page 1
                    startingPage = 1;
                }
                else if (currentPageNumber > paginationTotal - pageLinkMax) {
                    // Within range of last page
                    startingPage = paginationTotal - pageLinkMax + 1;
                }
                else {
                    startingPage = currentPageNumber - windowMath.floor(pageLinkMax / 2);
                }
                // Loop for page link max or total pages, whichever is lower
                for (let index = 0; index < windowMath.min(pageLinkMax, paginationTotal); index += 1) {
                    // Build page links
                    const page = window.document.createElement("li");
                    page.classList.add("page");
                    const startingPagePlusIndex = startingPage + index;
                    if (startingPagePlusIndex === 1) {
                        page.classList.add("first");
                    }
                    if (startingPagePlusIndex === currentPageNumber) {
                        page.classList.add("current");
                    }
                    if (startingPagePlusIndex === currentPageNumber) {
                        // Insert unwrapped text
                        page.innerHTML = window.String(startingPagePlusIndex);
                    }
                    else {
                        // Create link
                        const link = window.document.createElement("a");
                        link.href = getUrl(startingPagePlusIndex);
                        link.innerHTML = window.String(startingPagePlusIndex);
                        page.append(link);
                    }
                    pagination.append(page);
                }
            }
            // Ellipses and last page link
            if (currentPageNumber < paginationTotal - pageLinkMax + 1) {
                // Build ellipses
                const ellipses = window.document.createElement("li");
                ellipses.classList.add("ellipses");
                ellipses.innerHTML = "...";
                pagination.append(ellipses);
            }
            // Build next link
            if (currentPageNumber < paginationTotal) {
                const next = window.document.createElement("li");
                next.classList.add("next");
                const link = window.document.createElement("a");
                link.href = getUrl(currentPageNumber + 1);
                link.innerHTML = "&gt;";
                next.append(link);
                const label = window.document.createElement("span");
                label.innerHTML = "Next";
                link.append(label);
                pagination.append(next);
            }
        }
    }, []);
    return _jsx("div", Object.assign({ className: "integratedSearchPaginationWrapper" }, { children: _jsx("div", Object.assign({ className: "container" }, { children: _jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: "col-md-12" }, { children: _jsx("ul", { className: "integratedSearchPaginationPagination", ref: reference }) })) })) })) }));
};
export { IntegratedSearchPaginationComponent };
